<ng-container *ngIf="perms$.permissions | async as perms">
  <div class="rule__section-container flex items-center gap-2">
    <h3 class="input__editable nomargin flex items-center gap-2">
      <sbnb-icon icon="edit" class="text-smoke-darker"></sbnb-icon>
      <span
        #nameSpan
        style="padding-left: 0; padding-right: 8px; visibility: hidden; position: absolute; left: -9999px">
        {{ property.name }}
      </span>

      <input
        class="input__borderless"
        type="text"
        [style.width.px]="nameSpan.getBoundingClientRect().width"
        [(ngModel)]="property.name"
        [class.strikethrough]="property.muted"
        (change)="updateProperty()" />
    </h3>

    <sbnb-cs-debug-item
      label="Property ID"
      [coreNovaLink]="'/resources/properties/' + property.id"
      [value]="property.id"
      linkLabel="Nova"></sbnb-cs-debug-item>

    <div *ngIf="saveStatus && saveStatus !== 0" class="save-status">
      <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
    </div>
  </div>

  <div class="rule__section-container">
    <h3 class="not-clickable flex flex-col sm:flex-row items-start sm:items-center gap-2">
      <div class="flex items-center gap-2">
        <sbnb-icon icon="properties" class="shrink-0 text-smoke-darker"></sbnb-icon>
        <span>Listings in this property</span>
      </div>

      <div class="flex items-center gap-2 w-full sm:w-auto sm:ml-auto">
        <sbnb-button
          *ngIf="hasAirbnbListings"
          size="mini"
          type="secondary"
          (click)="openOpportunities()"
          mat-flat-button>
          <mat-icon class="align-middle mr-1">lightbulb</mat-icon>
          <span class="align-middle">Review opportunities</span>
        </sbnb-button>

        <sbnb-button
          label="Add a listing"
          size="mini"
          type="secondary"
          [matMenuTriggerFor]="availableListings && availableListings.data.length === 0 ? null : addListingMenu"
          [hidden]="availableListings && availableListings.data.length === 0"
          mat-flat-button></sbnb-button>
      </div>
    </h3>

    <mat-menu #addListingMenu="matMenu" class="filters__cdk-menu filters__cdk-menu-320">
      <mat-spinner *ngIf="availableListings?.loading" style="margin: auto" diameter="30"></mat-spinner>

      <input
        *ngIf="availableListings?.data?.length >= numListOptionsForSearchBar"
        class="filters__input-list-search"
        [(ngModel)]="searchCriteria"
        type="text"
        placeholder="Search"
        (click)="$event.stopPropagation()" />

      <div class="filter__list-fixed-height" *ngIf="availableListings?.data?.length > 0">
        <ng-container *ngFor="let option of availableListings.data">
          <button
            *ngIf="filtersMatchSearchCriteria(option, searchCriteria) && option.property?.muted === property.muted"
            mat-menu-item
            class="listing-menu-item"
            (click)="addListing(option)">
            <span fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
              <img
                *ngIf="option.picture"
                fxFlex="0 0 24px"
                class="filter__option-img"
                style="height: 24px"
                [src]="option.picture" />

              <div *ngIf="!option.picture" class="property-default-img" fxFlex="0 0 24px" fxLayoutAlign="center center">
                <mat-icon>cottage</mat-icon>
              </div>

              <div>
                <span class="ellipsis">{{ option.name }}</span>
                <span *ngIf="option.platform_key === 'booking'" class="text__xsmall">
                  Room ID: {{ option.listing_id }}
                </span>
              </div>
            </span>
          </button>
        </ng-container>
      </div>

      <div *ngIf="availableListings && availableListings.data.length === 0" class="properties__no-listings text__small">
        No viable listings to add
      </div>
    </mat-menu>

    <div *ngIf="property.listings?.length === 0">No listings in this property (yet)</div>

    <div
      *ngFor="let listing of property.listings"
      class="properties__container flex items-center gap-4"
      [class.is-lead-listing]="listing.is_lead_listing"
      [ngClass.lt-md]="{ mobile: true }"
      [class.listing__unavailable]="!listing.restrictions.available">
      <img fxHide.lt-md class="properties__img" width="136" [src]="listing.picture" />
      <div class="flex-1">
        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
          <h4>
            <a *ngIf="listing.public_url" [href]="listing.public_url" target="_blank">{{ listing.name }}</a>
            <span *ngIf="!listing.public_url">{{ listing.name }}</span>
          </h4>
          <sbnb-cs-debug-item label="listing_id" [value]="listing.listing_id"></sbnb-cs-debug-item>
        </div>
        <div class="flex items-center justify-between">
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon-smartbnb
              *ngIf="
                listing.platform_key === 'direct' || listing.platform_key === 'manual' || listing.platform_key === 'gvr'
              "></sbnb-icon-smartbnb>
            <sbnb-icon-airbnb
              [size]="14"
              *ngIf="
                (listing.platform_key | lowercase) === 'airbnb' ||
                (listing.platform_key | lowercase) === 'airbnb-official'
              "></sbnb-icon-airbnb>
            <sbnb-icon-homeaway
              [size]="14"
              *ngIf="(listing.platform_key | lowercase) === 'homeaway'"></sbnb-icon-homeaway>
            <sbnb-icon-booking [size]="14" *ngIf="(listing.platform_key | lowercase) === 'booking'"></sbnb-icon-booking>
            <sbnb-icon-agoda [size]="14" *ngIf="(listing.platform_key | lowercase) === 'agoda'"></sbnb-icon-agoda>
            <span class="text__small night-lighter">{{ listing.listing_type }}</span>
            <ng-container *ngIf="listing.host && listing.platform_key !== 'booking'">
              <span>•</span>
              <img
                *ngIf="listing.host.picture_url"
                [src]="listing.host.picture_url"
                style="height: 14px; width: 14px; border-radius: 50%" />
              <span class="night-lighter text__small">{{ listing.host.name }}</span>
            </ng-container>

            <ng-container *ngIf="listing.platform_key === 'booking'">
              <span>•</span>
              <span class="night-lighter text__small">Room ID: {{ listing.listing_id }}</span>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-2 self-center" data-element="listing-badges">
        <ng-container *ngIf="listing.is_lead_listing">
          <span class="badge badge-grass">Lead listing</span>
        </ng-container>

        <a
          *ngIf="listing.quality_standard_status"
          target="_blank"
          [href]="'https://www.airbnb.com/performance/listing-issues/' + listing.listing_id"
          [matTooltip]="listing.quality_standard_status.description"
          class="inline-flex items-center">
          <sbnb-badge [context]="listing.quality_standard_status.category">
            {{ listing.quality_standard_status.label }}
          </sbnb-badge>
        </a>

        <span
          *ngIf="!listing.restrictions.available"
          fxHide.lt-sm
          class="badge badge-lemon pms-connected-badge"
          [matTooltipClass]="'tooltip-dark'"
          [matTooltip]="'This listing is unlisted and its calendar cannot be read/updated.'"
          data-element="unlisted-badge">
          <sbnb-icon [size]="17" icon="details" class="text-smoke-darker"></sbnb-icon>
          <span>Unlisted</span>
        </span>

        <span
          *ngIf="listing.restrictions.calendar_restricted"
          fxHide.lt-sm
          class="badge badge-lemon pms-connected-badge"
          [matTooltipClass]="'tooltip-dark'"
          [matTooltip]="'This listing is calendar restricted and its calendar cannot be updated.'"
          data-element="calendar-restricted-badge">
          <sbnb-icon [size]="17" icon="details" class="text-smoke-darker"></sbnb-icon>
          <span fxHide.lt-lg>Calendar</span>
          Restricted
        </span>

        <span
          *ngIf="listing.restrictions.unclaimed"
          fxHide.lt-sm
          class="badge badge-lemon pms-connected-badge"
          [matTooltipClass]="'tooltip-dark'"
          [matTooltip]="'This listing is unclaimed and its calendar cannot be updated.'"
          data-element="unclaimed-badge">
          <sbnb-icon [size]="17" icon="details" class="text-smoke-darker"></sbnb-icon>
          <span fxHide.lt-lg>Calendar</span>
          Restricted
        </span>

        <span
          *ngIf="listing.restrictions.is_pms_connected"
          class="badge badge-lemon pms-connected-badge"
          [matTooltipClass]="'tooltip-dark'"
          [matTooltip]="
            'This listings calendar cannot be read/updated while another property management software is connected.'
          "
          data-element="pms-connected-badge">
          <sbnb-icon [size]="17" icon="details" class="text-smoke-darker"></sbnb-icon>
          <span fxHide.lt-lg>Calendar</span>
          Restricted
        </span>

        <span
          *ngIf="listing.restrictions.missing_rate_plans"
          fxHide.lt-sm
          class="badge badge-lemon pms-connected-badge"
          [matTooltipClass]="'tooltip-dark'"
          [matTooltip]="
            'This listing does not have a rate plan. Please add a rate plan to this listing in your Booking.com account.'
          "
          data-element="missing-rate-plan-badge">
          <sbnb-icon [size]="17" icon="details" class="text-smoke-darker"></sbnb-icon>
          <span>Missing Rate Plan</span>
        </span>
      </div>

      <div
        class="flex items-center gap-2 mr-3"
        [hidden]="
          listing.platform_key === 'direct' || listing.platform_key === 'manual' || listing.platform_key === 'gvr'
        ">
        <sbnb-more-menu-trigger
          *ngIf="property.listings.length > 1"
          [matMenuTriggerFor]="actionsMenu"></sbnb-more-menu-trigger>
        <mat-menu #actionsMenu="matMenu">
          <button
            mat-menu-item
            *ngIf="property.listings.length > 1 && !listing.is_lead_listing && listing.restrictions.available"
            (click)="showLeadListingDialog(listing)">
            <span>Set as lead listing</span>
          </button>

          <button
            mat-menu-item
            *ngIf="listing.restrictions.can_change_listed_status"
            (click)="updateListingStatus(listing)">
            <span>{{ listing.restrictions.available ? 'Unlist' : 'List' }} listing</span>
          </button>

          <button mat-menu-item *ngIf="property.listings.length > 1" (click)="removeListing(listing)">
            <span>Remove from property</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      *ngIf="bookingComPropertyManagementEnabled"
      fxLayout
      fxLayoutGap="16px"
      class="properties__container booking-cta"
      [ngClass.lt-md]="{ mobile: true }">
      <img
        fxHide.lt-md
        class="properties__img"
        fxFlex="120px"
        src="/assets/images/connected-accounts/booking.svg"
        alt="Booking.com Logo" />

      <div fxFlex fxLayout="column" fxLayoutGap="8px">
        <div class="flex items-center">
          <h3 class="text-lg font-medium m-0">List on Booking.com</h3>
        </div>
        <span class="text-gray-600 leading-normal">
          Expand your reach on Booking.com. We will automatically transfer your Airbnb listing details to get you
          started. Nothing will be published without your approval.
        </span>
      </div>

      <div fxLayout="column" fxLayoutAlign="center end" class="properties__right">
        <sbnb-button type="primary" (click)="openCreateBookingDialog()" data-tour="create-booking-listing">
          Continue
        </sbnb-button>
      </div>
    </div>
  </div>

  <sbnb-alert-card
    *ngIf="syncRestricted"
    context="warning"
    class="p-6 mt-5 leading-relaxed"
    data-element="sync-warning">
    <sbnb-icon icon="alert-triangle" class="text-rose-darker mr-2"></sbnb-icon>
    <div>
      <div>
        One or more of your listings is restricted from syncing and we will not be able to sync any updates to those
        listings.
      </div>
      <div class="mt-2">
        <a target="_blank" (click)="openIntercomHelp('10401728')">
          <sbnb-button type="secondary" size="mini" class="mt-4">Learn more</sbnb-button>
        </a>
      </div>
    </div>
  </sbnb-alert-card>

  <div class="my-12">
    <sbnb-property-detail-icals [property]="property"></sbnb-property-detail-icals>
  </div>

  <div class="rule__section-container rule__section-collapsed">
    <div fxLayout fxLayoutAlign="start center">
      <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="16px" class="not-clickable">
        <mat-slide-toggle
          [disabled]="property.listings?.length < 2 || property.parent_child_type"
          [matTooltip]="
            property.parent_child_type
              ? 'Sync can not be disabled because this property is in a parent-child relationship'
              : property.listings?.length < 2
                ? 'You need 2 or more listings associated to this property to enable Sync'
                : ''
          "
          (click)="$event.stopPropagation()"
          [checked]="property.sync"
          (change)="syncStatusChange($event)"></mat-slide-toggle>
        <div fxLayoutAlign="start center" fxLayoutGap="10px">
          <sbnb-icon icon="sync" class="text-smoke-darker"></sbnb-icon>
          <span>Sync</span>
        </div>
        <span *ngIf="property.listings?.length >= 2" class="card__collapsed-helper-text">
          Sync information between listings in this property to avoid double bookings, according to your
          <a class="grass-darker strong" [routerLink]="['/settings/sync']">Sync settings</a>
        </span>
        <span *ngIf="property.listings?.length < 2" class="card__collapsed-helper-text raspberry-darker">
          You need 2 or more listings associated to this property to enable Sync
        </span>
      </h3>
    </div>
  </div>

  <div class="rule__section-container" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
    <ng-container>
      <div
        fxFlex
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutAlign.lt-md="start start"
        fxLayoutGap="16px"
        fxLayout.lt-md="column">
        <h3 fxLayoutAlign="start center" fxLayoutGap="12px" class="not-clickable nomargin">
          <img src="/assets/iconography/calendar-upload.svg" class="img-icon" alt="properties" />
          <span>Export calendar</span>
        </h3>
        <span class="text__small night-lighter" fxFlex>
          Send your reservations to an external calendar or third party integrations via iCal.
        </span>
      </div>
      <sbnb-button
        *ngIf="property.ical_feed"
        mat-flat-button
        size="mini"
        type="secondary"
        label="Copy iCal link"
        ngxClipboard
        [cbContent]="property.ical_feed.replace('webcal', 'https')"
        (click)="copiedToClipboard()"></sbnb-button>
      <sbnb-more-menu-trigger *ngIf="property.ical_feed" [matMenuTriggerFor]="icalMenu"></sbnb-more-menu-trigger>
    </ng-container>
  </div>

  <mat-menu #icalMenu="matMenu">
    <a mat-menu-item [href]="property.ical_feed | safe: 'resourceUrl'" target="_blank">
      <span>Open in calendar application</span>
    </a>
    <button mat-menu-item (click)="resetCalendar()">
      <span>Revoke calendar access</span>
    </button>
  </mat-menu>

  <!-- Parent/child display, only for properties already in a relationship -->
  <sbnb-parent-child-relationship-visualiser
    *ngIf="property.parent_child_type"
    [propertyId]="property.id"></sbnb-parent-child-relationship-visualiser>

  <div class="rule__section-container" fxLayout fxLayoutAlign="space-between center">
    <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
      <sbnb-button
        *ngIf="!property.muted && perms.is_team_owner"
        [type]="'secondary'"
        size="mini"
        label="Mute Property"
        type="text"
        (clicked)="muteProperty('mute')"></sbnb-button>

      <ng-container *ngIf="property.muted && perms.is_team_owner">
        <sbnb-button
          *ngIf="canUnmute$ | async; else upgradeCTA"
          [type]="'primary'"
          label="Unmute"
          type="text"
          (clicked)="muteProperty('unmute')"></sbnb-button>
        <ng-template #upgradeCTA>
          <sbnb-button [routerLink]="['/settings/your-plan']">Upgrade to unmute more properties</sbnb-button>
        </ng-template>
      </ng-container>
    </div>

    <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
  </div>
</ng-container>
